import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import './Apply.css';

// EmailJS Details
const EMAILJS_SERVICE_ID = 'service_tidothx';
const EMAILJS_TEMPLATE_ID = 'template_40yno8m';
const EMAILJS_PUBLIC_KEY = 'UiKExzyFAeT1tYjGU';

const EnquiryForm = ({ closeModal }) => {
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    course: '',
  });

  const [isFormValid, setIsFormValid] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    const isValid = Object.values(formData).every(
      (value) => value.trim() !== ''
    );

    setIsFormValid(isValid);
  }, [formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormValid) return;

    setIsSubmitting(true);
    setSuccessMessage('');
    setErrorMessage('');

    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          firstname: formData.firstname,
          lastname: formData.lastname,
          email: formData.email,
          phone: formData.phone,
          course: formData.course,

          // Current date & time
          time: new Date().toLocaleString('en-IN', {
            dateStyle: 'medium',
            timeStyle: 'short',
          }),
        },
        EMAILJS_PUBLIC_KEY
      );

      setSuccessMessage(
        'Your enquiry has been submitted successfully!'
      );

      setErrorMessage('');

      // Reset form
      setFormData({
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        course: '',
      });

      // Close modal after 2 seconds
      setTimeout(() => {
        closeModal();
      }, 2000);

    } catch (error) {
      console.error('EmailJS Error:', error);

      setErrorMessage(
        'Error submitting the form. Please try again.'
      );

      setSuccessMessage('');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">

      <div className="modal-content">

        {/* Close Button */}
        <button
          className="close-btn"
          onClick={closeModal}
          type="button"
        >
          &times;
        </button>

        <h2 className="modal-title">
          Enquiry Form
        </h2>

        {/* Success Message */}
        {successMessage && (
          <p className="success-message">
            {successMessage}
          </p>
        )}

        {/* Error Message */}
        {errorMessage && (
          <p className="error-message">
            {errorMessage}
          </p>
        )}

        <form
          onSubmit={handleSubmit}
          className="form-container"
        >

          {/* First Name */}
          <div className="form-group">
            <input
              type="text"
              name="firstname"
              value={formData.firstname}
              onChange={handleInputChange}
              placeholder="First Name"
              required
            />
          </div>

          {/* Last Name */}
          <div className="form-group">
            <input
              type="text"
              name="lastname"
              value={formData.lastname}
              onChange={handleInputChange}
              placeholder="Last Name"
              required
            />
          </div>

          {/* Email */}
          <div className="form-group">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Email Address"
              required
            />
          </div>

          {/* Phone */}
          <div className="form-group">
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder="Phone Number"
              required
            />
          </div>

          {/* Course */}
          <div className="form-group">
            <select
              name="course"
              value={formData.course}
              onChange={handleInputChange}
              required
            >
              <option value="">
                Choose Course
              </option>

              <option value="D.Pharmacy">
                D.Pharmacy
              </option>
            </select>
          </div>

          {/* Submit */}
          <button
            type="submit"
            className="submit-btn"
            disabled={!isFormValid || isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>

        </form>

      </div>

    </div>
  );
};

export default EnquiryForm;
